import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { getStyle } from '../../../utils/utils';
import CBMediaQuery from '../../shared/CBMediaQuery';
import CBSubHeading from '../../shared/CBSubHeading';
import CBSelectField from '../../shared/form_components/CBSelectField';
import {
  fetchChains as _fetchChains,
  fetchChainPermissions as _fetchChainPermissions,
  createChainPermission as _createChainPermission,
  deleteChainPermission as _deleteChainPermission,
} from '../../../actions/chainActions';
import PermissionRow from './PermissionRow';

class StaffSettingsChainPermissions extends React.Component {
  state = {
    selectedChain: undefined,
  };

  componentDidMount() {
    const { fetchChains } = this.props;
    fetchChains();
  }

  componentWillReceiveProps(nextProps) {
    const { selectedChain } = this.state;
    const { chains } = this.props;

    if ((!chains || !chains.length) && (nextProps.chains && nextProps.chains.length)) {
      const chain = nextProps.chains[0];
      this.setState({ selectedChain: chain });
      this.props.fetchChainPermissions(chain.id);
    }

    if (nextProps.chains && nextProps.chains.length && selectedChain) {
      this.setState({
        selectedChain: nextProps.chains.find(c => c.id === selectedChain.id),
      });
    }
  }

  getChainOptions = () => {
    const { chains } = this.props;
    return chains.map(chain => ({
      label: chain.name,
      value: chain.id,
    }));
  };

  chainChanged = (selected) => {
    const { chains, fetchChainPermissions } = this.props;
    const chainId = Number.parseInt(selected.value, 10);
    const chain = chains.find(c => c.id === chainId);
    this.setState({ selectedChain: chain });
    fetchChainPermissions(chainId);
  };

  getSelectedChain = () => {
    const { chains } = this.props;
    let { selectedChain } = this.state;
    if (!selectedChain && chains.length) {
      [selectedChain] = chains;
    }
    return selectedChain;
  };

  createPermission = (data) => {
    const { createChainPermission, fetchChainPermissions } = this.props;
    const selectedChain = this.getSelectedChain();
    createChainPermission(data).then(() => {
      if (selectedChain) {
        fetchChainPermissions(selectedChain.id);
      }
    });
  };

  deletePermission = (permissionId) => {
    const { deleteChainPermission } = this.props;
    deleteChainPermission(permissionId);
  };

  render() {
    const { t, chainPermissions, user } = this.props;
    const selectedChain = this.getSelectedChain();

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <CBSubHeading>
              {t('chainPermissionsHeading')}
            </CBSubHeading>

            <div style={getStyle(screenSize, styles, 'chainSelectorContainer')}>
              <CBSelectField
                containerStyle={getStyle(screenSize, styles, 'selectContainer')}
                inputStyle={getStyle(screenSize, styles, 'selectField')}
                optionStyle={getStyle(screenSize, styles, 'optionStyle')}
                options={this.getChainOptions()}
                placeholder=''
                labelText={t('labelChain')}
                value={selectedChain && selectedChain.id}
                onChange={this.chainChanged}
              />
            </div>

            {selectedChain && (
              <React.Fragment>
                <table>
                  <thead>
                    <tr>
                      <th style={getStyle(screenSize, styles, 'tableHeading')}>
                        {t('userTableHeading')}
                      </th>
                      <th style={getStyle(screenSize, styles, 'tableHeading')}>
                        {t('descriptionTableHeading')}
                      </th>
                      <th style={getStyle(screenSize, styles, 'tableHeading')}>
                        {t('permissionTableHeading')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {chainPermissions && chainPermissions.map(permission => (
                      <PermissionRow
                        key={permission.id}
                        permission={permission}
                        deletePermission={this.deletePermission}
                        canEdit={user && user.is_staff}
                        userRole='admin'
                        isChainPermission
                        chain={selectedChain}
                      />
                    ))}
                    {user && user.is_staff && (
                      <PermissionRow
                        isNew
                        chain={selectedChain}
                        permission={{
                          user_email: '',
                          role: 'employee',
                          description: '',
                        }}
                        createPermission={this.createPermission}
                        canEdit
                        userRole='admin'
                        isChainPermission
                      />
                    )}
                  </tbody>
                </table>
              </React.Fragment>
            )}
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      padding: 32,
      display: 'flex',
      flexDirection: 'column',
    },
    chainSelectorContainer: {
      display: 'flex',
      alignItems: 'flex-end',
    },
    selectField: {
      minWidth: 300,
      height: 40,
      border: '1px solid rgb(255 255 255 / 55%)',
      borderRadius: 50,
      backgroundColor: 'transparent',
      color: '#FFF',
      padding: '0px 0px 0px 16px',
    },
    selectContainer: {
      marginTop: 16,
      marginRight: 16,
      minWidth: 300,
    },
    tableHeading: {
      fontFamily: 'TitilliumWeb-Regular',
      fontSize: 12,
      color: '#ffffff',
      paddingLeft: 16,
      paddingBottom: 8,
    },
    optionStyle: {
      backgroundColor: 'rgb(0, 149, 218)',
    },
  },
  medium: {
    container: {
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
    },
  },
};

function mapStateToProps(state) {
  return {
    chains: state.chain.chains,
    chainPermissions: state.chain.chainPermissions,
    user: state.authUser.user,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchChains: _fetchChains,
    fetchChainPermissions: _fetchChainPermissions,
    createChainPermission: _createChainPermission,
    deleteChainPermission: _deleteChainPermission,
  },
)(translate('Permissions')(StaffSettingsChainPermissions));
